const menuList = [
    {
        path: '/home',
        icon: 'el-icon-s-home',
        label: '工作台',
    },
    {
        label: '经营',
        icon: 'el-icon-s-marketing',
        actions: [
            'optSuper',
            'biz.warehouse.order.info.list',
            'biz.warehouse.payment.info.list'
        ],
        children: [
            {
                path: '/warehouse/warehouse-order',
                label: '订单记录',
                actions: [
                    'optSuper',
                    'biz.warehouse.order.info.list'
                ],
            },
            {
                path: '/warehouse/warehouse-unmanned-order',
                label: '渠道订单',
                actions: [
                    'optSuper',
                    'biz.warehouse.order.info.list'
                ],
            },
            {
                label: '收款记录',
                path: '/warehouse/warehouse-payment',
                actions: [
                    'optSuper',
                    'biz.warehouse.payment.info.list'
                ],
            },
            {
                label: '退款记录',
                path: '/warehouse/warehouse-payment-refund',
                actions: [
                    'optSuper',
                    'biz.warehouse.payment.refund.list'
                ],
            },
        ]
    },
    {
        label: '商品',
        icon: 'el-icon-s-goods',
        actions: [
            'optSuper'
        ],
        children: [
            {
                label: '商品信息',
                path: '/goods/goods-sku-list',
                actions: [
                    'optSuper'
                ],
            },
            {
                label: '组合商品',
                path: '/goods/goods-combination',
                actions: [
                    'optSuper'
                ],
            },
            {
                label: '店内分类',
                path: '/goods/goods-classify',
                actions: [
                    'optSuper'
                ],
            },
        ]
    },
    {
        label: '库存',
        icon: 'el-icon-s-order',
        actions: [
            'optSuper',
            'biz.warehouse.inventory.info.list',
            'biz.warehouse.goods.info.list',
        ],
        children: [
            {
                label: '出入记录',
                path: '/warehouse/warehouse-inventory',
                actions: [
                    'optSuper',
                    'biz.warehouse.inventory.info.list'
                ],
            },
            {
                label: '门店库存',
                path: '/warehouse/warehouse-goods',
                actions: [
                    'optSuper',
                    'biz.warehouse.goods.info.list'
                ],
            },
            // {
            //     label: '线下服务',
            //     path: '/customer/customer-store-service',
            //     actions: [
            //         'optSuper',
            //         'biz.customer.store.service.list'
            //     ],
            // },
        ]
    },
    {
        label: '仓库',
        icon: 'el-icon-truck',
        actions: [
            'optSuper',
            'biz.warehouse.purchase.info.list',
            'biz.warehouse.transfer.info.list',
            'biz.warehouse.replenish.info.list',
        ],
        children: [
            {
                label: '补货计划',
                path: '/warehouse/warehouse-purchase',
                actions: [
                    'optSuper',
                    'biz.warehouse.purchase.info.list'
                ],
            },
            {
                label: '调研任务',
                path: '/warehouse/warehouse-survey',
                actions: [
                    'optSuper',
                    'biz.warehouse.survey.info.list'
                ],
            },
            {
                label: '补货记录【旧版】',
                path: '/warehouse/warehouse-replenish',
                actions: [
                    'optSuper',
                    'biz.warehouse.replenish.info.list'
                ],
            },
        ]
    },
    {
        label: '兽药',
        icon: 'el-icon-s-check',
        actions: [
            'optSuper',
        ],
        children: [
            {
                label: '追溯查询',
                path: '/warehouse/warehouse-veterinary-zsm',
                actions: [
                    'optSuper',
                    'biz.data.vet.zsm.info.query',
                ],
            },
            {
                label: '处方管理',
                path: '/warehouse/warehouse-veterinary-prescription',
                actions: [
                    'optSuper',
                    'biz.warehouse.veterinary.prescription.list',
                ],
            },
            {
                label: '上传记录',
                path: '/warehouse/warehouse-veterinary-upload',
                actions: [
                    'optSuper',
                    'biz.warehouse.vet.upload.list',
                ],
            },
            {
                label: '经营台账',
                path: '/warehouse/warehouse-veterinary-receipt',
                actions: [
                    'optSuper',
                    'biz.warehouse.vet.receipt.list',
                ],
            },
        ]
    },
    {
        label: '设置',
        icon: 'el-icon-setting',
        actions: [
            'optSuper',
        ],
        children: [
            {
                label: '商户配置',
                path: '/customer/customer-config',
                actions: ['optSuper'],
            },
        ]
    },
];

export function getMenus() {
    return menuList;
}
